import React from 'react'
import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import { AttachmentInfoContainer } from './styled'
import { StdForm } from 'components'
import { FileRow } from './FileRow'
import { FileRow1 } from './FileRow1'
import { ProcurementBody } from '../../../styled'
import { Fade, } from '@material-ui/core'

const DPAttachment = (props) => {
  const { valueForm, dpDetail } = props

  const attachments = [
    {
      title: 'Invoice / Tax Invoice :    ',
      items: [
        {
          fileName: '4100000852 : Payment Certificate',
          fileSize: 1771,
        },
      ]
    },
    {
      title: 'Payment Certificate/Acknowled Doc.:  ',
      items: [
        {

          fileName: '4100000852 : Payment Certificate',
          fileSize: 1771,
        }
      ]
    }, 
  ]

  function setAttachment() {
    if (valueForm.downPaymentAttachments.length) {
      let invoiceFiles = valueForm.downPaymentAttachments.filter(a => a.documentType === 'DP01')
        return (<FileRow invoiceFiles={invoiceFiles}  />)
    } else {
      return null
    }
  }

  function setAttachments() {
    if (valueForm) {
      let invoice = valueForm.downPaymentAttachments.filter(a => a.documentType === 'DP01')
        return <FileRow invoiceFiles={invoice}  />
    } else {
      return null
    }
  }

  function setAttachment1() {
    if (valueForm.downPaymentAttachments.length) {
      let interimFiles = valueForm.downPaymentAttachments.filter(a => a.documentType === 'DP02')
        return <FileRow1 interimFiles={interimFiles} />
    } else {
      return null
    }
  }
  
  return (
    <Fade in={true} timeout={1000}>
      <ProcurementBody>
        <StdForm title="Attachment">
          <AttachmentInfoContainer>
            
            {!dpDetail.isVendThai ?
              setAttachments()
              :
              setAttachment()
            }
            {setAttachment1()}
          </AttachmentInfoContainer>
        </StdForm>
      </ProcurementBody>
    </Fade>
  )
}

const mapStateToProps = (state) => ({
  dpDetail: state.downPayment.downPaymentDetail.data,
  valueForm: getFormValues('formDP')(state),
})
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(DPAttachment)
